import {
  getCommonProductTerms,
  getVerticalWidgetProductTerms,
  ServicesWithTerms,
} from '@sravni/react-ugc/lib/ProductTerms';
import { EDUCATION_OFFERS, LEARNING_TYPES } from '@sravni/ugc/lib/specialOffers/lists';
import type { LearningTypes } from '@sravni/ugc/lib/specialOffers/types';

import type { OfferTab } from '../../helpers/getTabsInfo';

export const learningTypeInfo: Record<LearningTypes, OfferTab> = {
  [LEARNING_TYPES.typeProgramming]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeProgramming },
    label: 'Программирование',
    generalLink: '/kursy/programmirovanie/',
    generalLinkLabel: 'Все курсы по программированию',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.educationalType),
  },
  [LEARNING_TYPES.typeAnalytics]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeAnalytics },
    label: 'Аналитика',
    generalLink: '/kursy/analitika/',
    generalLinkLabel: 'Все курсы по аналитике',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeMarketing]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeMarketing },
    label: 'Маркетинг',
    generalLink: '/kursy/marketing/',
    generalLinkLabel: 'Все курсы по маркетингу',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeDesign]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeDesign },
    label: 'Дизайн',
    generalLink: '/kursy/dizajn-graficheskij/',
    generalLinkLabel: 'Все курсы по дизайну',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeManagement]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeManagement },
    label: 'Бизнес и управление',
    generalLink: '/kursy/menedzhment/',
    generalLinkLabel: 'Все курсы по бизнесу и управлению',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeAdmin]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeAdmin },
    label: 'Администрирование',
    generalLink: '/kursy/programmirovanie-sistemnoe-administrirovanie/',
    generalLinkLabel: 'Все курсы по администрированию',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeFinance]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeFinance },
    label: 'Финансы',
    generalLink: '/kursy/finansy/',
    generalLinkLabel: 'Все курсы по финансам',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeLanguage]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeLanguage },
    label: 'Иностранные языки',
    generalLink: '/kursy/inostrannye-yazyki/',
    generalLinkLabel: 'Все курсы по иностранным языкам',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeCreativity]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeCreativity },
    label: 'Творчество и создание контента',
    generalLink: '/kursy/creativity-make/',
    generalLinkLabel: 'Все курсы по творчеству и созданию контента',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeSoftSkills]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeSoftSkills },
    label: 'Саморазвитие и soft skills',
    generalLink: '/kursy/samorazvitie/',
    generalLinkLabel: 'Все курсы по саморазвитию и soft skills',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeApplication]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeApplication },
    label: 'Рукоделие',
    generalLink: '/kursy/rukodelie/',
    generalLinkLabel: 'Все курсы по рукоделию',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeBeauty]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeBeauty },
    label: 'Красота и здоровье',
    generalLink: '/kursy/beauty/',
    generalLinkLabel: 'Все курсы по красоте и здоровью',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typePO]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typePO },
    label: 'Прикладные программы',
    generalLink: '/kursy/menedzhment-microsoft-office/',
    generalLinkLabel: 'Все курсы по прикладным программам',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeSport]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeSport },
    label: 'Спорт',
    generalLink: '/kursy/sport/',
    generalLinkLabel: 'Все курсы по спорту',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
  [LEARNING_TYPES.typeDPO]: {
    key: { type: EDUCATION_OFFERS.learning, subtype: LEARNING_TYPES.typeDPO },
    label: 'ДПО',
    generalLink: '/kursy/povyshenie-kvalifikacii/',
    generalLinkLabel: 'Все курсы по ДПО',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.educationalType),
    advertisingCategory: 'Курсы',
  },
};
